/**
 * GTM custom events helper.
 * Pushes flat events to window.dataLayer (no `ecommerce` object) and keeps the
 * context needed to enrich Elevar's dl_add_to_cart (add_source / purchase_type).
 */
(function () {
  if (window.AutobrushTracking) return;

  var ADD_CONTEXT_TTL = 15000;
  var addContext = null;

  function push(eventName, params) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, params));
  }

  function toPrice(cents) {
    var value = Number(cents);
    if (!isFinite(value)) return 0;
    return Math.round(value) / 100;
  }

  // Liquid's `json` output keeps HTML entities (e.g. "Subscribe &amp; Save").
  function decodeHtml(value) {
    if (!value) return '';
    var textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
  }

  function getMainItem() {
    var product = window.pdp && window.pdp.product_object;
    if (!product) return {};
    return { main_item_id: String(product.id), main_item_name: decodeHtml(product.title) };
  }

  function getCart() {
    return fetch((window.routes ? window.routes.cart_url : '/cart') + '.js')
      .then(function (response) {
        return response.json();
      })
      .catch(function () {
        return null;
      });
  }

  // Cart subtotal / item count, read before the shopper's action changes the cart.
  function getCartContext() {
    return getCart().then(function (cart) {
      if (!cart) return {};
      return { cart_value: toPrice(cart.items_subtotal_price), cart_item_count: cart.item_count };
    });
  }

  function getPurchaseType(form) {
    var plan = form && form.querySelector('[name="selling_plan"]');
    return plan && plan.value ? 'subscription' : 'one_time';
  }

  // Remember where the next cart add came from so the Elevar transform can read it.
  function setAddContext(source, purchaseType) {
    addContext = { add_source: source, purchase_type: purchaseType, at: Date.now() };
  }

  function consumeAddContext() {
    var context = addContext;
    addContext = null;
    if (!context || Date.now() - context.at > ADD_CONTEXT_TTL) return null;
    return context;
  }

  // Every product-form add: record purchase_type, and flag cart recommendation adds as upsells.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.closest || !form.closest('product-form')) return;
      var isCartUpsell = !!form.closest('cart-recommendations');
      setAddContext(isCartUpsell ? 'cart_upsell' : undefined, getPurchaseType(form));
      if (isCartUpsell) trackCartRecInteraction('add', form.closest('.card-wrapper'));
    },
    true
  );

  // Cart drawer recommendation cards (cart_upsell_interaction).
  function trackCartRecInteraction(interactionType, card) {
    if (!card) return;
    var items = Array.prototype.slice.call(document.querySelectorAll('cart-recommendations .card-wrapper'));
    getCartContext().then(function (cartContext) {
      push(
        'cart_upsell_interaction',
        Object.assign(
          {
            interaction_type: interactionType,
            upsell_item_id: card.dataset.id,
            upsell_item_name: card.dataset.productTitle,
            upsell_variant_id: card.dataset.variantId,
            upsell_price: toPrice(card.dataset.price),
            upsell_position: items.indexOf(card) + 1,
            cart_location: 'drawer',
          },
          cartContext
        )
      );
    });
  }

  // variant_select: fires only when the selected variant really changes.
  var lastVariant = window.pdp && window.pdp.currentVariant ? window.pdp.currentVariant : null;
  var pendingSelection = null;

  function getSelectionMethod(target) {
    if (!target || !target.closest) return 'button';
    if (target.tagName === 'SELECT' || target.closest('select, [data-split-options-member]')) return 'dropdown';
    if (target.closest('[class*="swatch"]')) return 'swatch';
    return 'button';
  }

  function getOptionName(product, index) {
    var option = product && product.options && product.options[index];
    return option && typeof option === 'object' ? option.name : option || '';
  }

  function trackVariantSelect(variant) {
    var product = window.pdp && window.pdp.product_object;
    var previous = lastVariant;
    lastVariant = variant;
    if (!product || !variant || !previous || String(previous.id) === String(variant.id)) return;

    var changedIndex = (variant.options || []).findIndex(function (value, index) {
      return value !== (previous.options || [])[index];
    });

    push('variant_select', {
      item_id: String(product.id),
      item_name: decodeHtml(product.title),
      variant_id: String(variant.id),
      variant_name: decodeHtml(variant.title),
      option_name: changedIndex > -1 ? getOptionName(product, changedIndex) : '',
      option_value: changedIndex > -1 ? variant.options[changedIndex] : '',
      previous_variant_id: String(previous.id),
      selection_method: pendingSelection || 'button',
      variant_price: toPrice(variant.price),
    });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function (payload) {
      var event = payload && payload.data && payload.data.event;
      pendingSelection = getSelectionMethod(event && event.target);
    });

    subscribe(PUB_SUB_EVENTS.variantChange, function (payload) {
      trackVariantSelect(payload && payload.data && payload.data.variant);
    });
  }

  window.AutobrushTracking = {
    trackCartRecInteraction: trackCartRecInteraction,
    push: push,
    toPrice: toPrice,
    decodeHtml: decodeHtml,
    getMainItem: getMainItem,
    getCartContext: getCartContext,
    getPurchaseType: getPurchaseType,
    setAddContext: setAddContext,
    consumeAddContext: consumeAddContext,
  };
})();
